import Vue from 'vue'

const state = {
    dateInterval: null,
    selectedEvent: null,
    expandedDay: null,
    currentView: null,
    filters: {
        product: true,
        resource: true,
        transport: true,
        availability: true,
        //booked: true,
    },
    eventNotes: [],
    selectedNote: null,
    editEventTab: null,
    storedDates: {},
    storedEvents: [],
    isloadingEvents: false,
    isloadingSelectedEvent: false,
    isCreatingSingleEvent: false,
    isUpdatingEvent: false,
    filterBlacklistProducts: [],
};

const getters = {
    getDateInterval: (state) => state.dateInterval,
    getSelectedEvent: (state) => state.selectedEvent,
    getExpandedDay: (state) => state.expandedDay,
    getCurrentView: (state) => state.currentView,
    getFilters: (state) => state.filters,
    getSelectedNote: (state) => state.selectedNote,
    getEventNotes: (state) => state.eventNotes,
    getEditEventTab: (state) => state.editEventTab,
    getStoredDates: (state) => state.storedDates,
    getStoredEvents: (state) => state.storedEvents,
    getIsLoadingEvents: (state) => state.isloadingEvents,
    getIsCreatSingleEvent: (state) => state.isCreatingSingleEvent,
    getIsloadingSelectedEvent: (state) => state.isloadingSelectedEvent,
    getIsUpdatingEvent: (state) => state.isUpdatingEvent,
    getfilterBlacklistProducts: (state) => state.filterBlacklistProducts,
    getProductsShowingOnCalendar: (state) => {
        let eventsOnDates = state.storedEvents.map(storedEvent => {
            if(
                moment(storedEvent.start).isAfter(moment(state.dateInterval.startDate))
                &&
                moment(storedEvent.end).isBefore(moment(state.dateInterval.endDate).endOf('day'))
            ){
                return storedEvent
            }
        })

        let products = [];

        eventsOnDates.forEach(event => {
            if(!event || !event.product){
                return false
            }
            //check if product is already present on products
            let filteredArr = products.filter(product => {
                return product.id == event.product.id
            })

            if (filteredArr.length == 0 && event && event.product.name) {
                products.push(event.product);
            }
        });

        return products
    }
};

const actions = {
    updateSidebar: ({ commit }, date) => {
        // console.log('updateSidebar');
        commit('UPDATE_CALENDAR_SIDEBAR', date);
    },

    updateExpandedDate: ({ commit }, date) => {
        commit('UPDATE_EXPANDED_DATE', date);
    },

    updateCurrentView: ({ commit }, view) => {
        commit('UPDATE_CURRENT_VIEW', view);
    },

    updateEditEventTab: ({ commit }, tabName) => {
        commit('UPDATE_EDIT_EVENT_TAB', tabName)
    },

    // Updates the currently selected event on the calendar, triggering
    // its sidebar detailed view. This can only happen after we finish
    // fetching the event notes from the API

    updateSelectedEvent: ({ state, commit, dispatch, rootState }, payload) => {
        if(typeof payload == "number"){

            dispatch('initEventNotes', payload)
            //downlaod the complete event from API
            // console.log('Fetching eventId: '+payload);
            state.isloadingSelectedEvent = true
            axios.get('api/calendar/GetEvents', {
                params: {
                    supplierId: rootState.user.account.supplierId,
                    eventId: payload
                }
            }).then(response => {
                state.isloadingSelectedEvent = false
                if (response && response.status === 200) {
                    commit('UPDATE_SELECTED_EVENT', response.data.events[0]);
                }
            }).catch(error => {
                console.log(error);
            })

        } else {
            commit('UPDATE_SELECTED_EVENT', payload);
        }

    },

    // Toggles a given filter on the calendar

    toggleCalendarFilter: ({ commit }, data) => {
        commit('TOGGLE_CALENDAR_FILTER', data);
    },

    setSelectedNote: ({ state, commit, rootState }, note) => {
        commit('SET_SELECTED_NOTE', note);
    },

    clearSelectedNote: ({ commit }) => {
        commit('CLEAR_SELECTED_NOTE');
    },

    initEventNotes: ({ commit, dispatch, rootState }, eventId) => {
        axios.get('/api/calendar/ListEventNote', { params: {
            supplierId: rootState.user.account.supplierId,
            eventId: eventId
        }}).then((response) => {
            if (response && response.status === 200) {
                commit('UPDATE_EVENT_NOTE_LIST', response.data);

                Vue.toasted.success(response.data.message);
            }
        })
        .catch(function(error) {
            //Vue.toasted.error(error);
        });
    },

    // Adds an event note (placebo for update method)
    // Parameters: { action: 'edit', fields: { object } }

    addEventNote: ({ dispatch }, data) => {
        dispatch('updateEventNote', data);
        dispatch('closeModal');
    },

    updateEventNote: ({ commit, dispatch }, data) => {
        if (!data.action) {
            throw new Error('Invalid action on updateEventNote');
        }

        let action = data.action.charAt(0).toUpperCase() + data.action.slice(1);

        axios.post('/api/calendar/' + action + 'EventNote', data.fields).then((response) => {
            if (response && response.status === 200) {
                dispatch('initEventNotes', response.data.eventId);
                dispatch('clearSelectedNote');
                dispatch('closeModal');

                Vue.toasted.success(response.data.message);
            }
        })
        .catch(function(error) {
            //Vue.toasted.error(error);
        });
    },

    deleteEventNote: ({ commit, dispatch }, fields) => {
        axios.post('/api/calendar/DeleteEventNote', fields).then((response) => {
            if (response && response.status === 200) {
                dispatch('initEventNotes', fields.eventNote.eventId);
                dispatch('clearSelectedNote');

                Vue.toasted.success(response.data.message);
            }
        })
        .catch(function(error) {
            //if(!(error.response.data !== undefined && error.response.data && error.response.data.message !== undefined && error.response.data.message)) {
            //    Vue.toasted.error(error)
            //}
        });
    },

    saveEventChanges: ({commit, dispatch, state}, data) => {
        state.isUpdatingEvent = true
        return new Promise((resolve, reject) => {

            axios.post('/api/calendar/EditEvent ', {
                supplierId: data.supplierId,
                deliverNotification: data.deliverNotification,
                event: state.selectedEvent
            }).then((response) => {
                state.isUpdatingEvent = false
                if (response && response.status === 200) {
                    Vue.toasted.success('Changes where sucessfully saved.');
                    dispatch('closeModal');
                    resolve(response) //response is not used for nothing, here for debug
                }
            })
            .catch(function(error) {
                state.isUpdatingEvent = false
                //Vue.toasted.error(error.message);
                reject(error)
            });

        })
    },

    cancelEventEdit: ({state, commit}, data) => {
        //swaps the state with a complete event that was saved before any changes
        commit('CANCEL_EVENT_EDIT', data);
    },

    async downloadEventsOLD ({state, commit, dispatch}, data) {
        try {
            //console.log('-- Download events --');
            let dateFrom = moment(data.dateFrom);
            let dateTo = moment(data.dateTo);
            let supplierId = data.supplierId;
            let timeToExpire = 0; //if an event is loaded but its X minutes old it downloads it again
            //debug
            //console.log('From: '+ dateFrom.format('YYYY-MM-DD') +' to '+dateTo.format('YYYY-MM-DD'));

            let numberOfDays = dateTo.diff(dateFrom, 'days');
            // debug
            //console.log('Requested '+ numberOfDays +' day(s)');

            //create array of requested dates
            let requestedDatesArr = []
            for (var i = 0; i < numberOfDays; i++) {
                let calculatedDate = dateFrom.clone().add(i, 'days').format('YYYY-MM-DD');
                //only adds if it is not download or the download is old and expired
                if(state.storedDates[calculatedDate] == undefined || moment().diff(moment(state.storedDates[calculatedDate].pullTime), 'minutes') > timeToExpire){
                    //requestedDatesArr.push(calculatedDate)
                } else {
                    //console.log('Will not download, already on memory: '+calculatedDate);
                }
                requestedDatesArr.push(calculatedDate) // delete this if the same is uncommented inside if
            }

            //console.log(requestedDatesArr);

            //download the needed events
            state.isloadingEvents = true;
            let axiosRequestArr = [];
            for (let dateToDownload of requestedDatesArr) {

                axiosRequestArr.push(
                    axios.get('api/calendar/GetEvents', {
                        params: {
                            supplierId: supplierId,
                            dateFrom: dateToDownload,
                            dateTo: dateToDownload
                        },
                    })
                )
            }

            await axios.all(axiosRequestArr).then(function(results) {
                let returnedEvents = [];
                for (let response of results) {

                    if (response && response.status === 200) {
                        for (let event of response.data.events) {
                            returnedEvents.push(event)
                        }
                    }
                }

                state.isloadingEvents = false;
                commit('ADD_TO_STORED_EVENTS', returnedEvents);
                dispatch('prepareEventDates');
            })
        } catch (err) {

        }



    },

    downloadEvents ({state, commit, dispatch}, data) {
        // console.log('-- Download events --');
        let dateFrom = moment(data.dateFrom).format('YYYY-MM-DD');
        let dateTo = moment(data.dateTo).subtract(1, 'day').format('YYYY-MM-DD');
        let supplierId = data.supplierId;

        // Update date interval state
        commit('UPDATE_CALENDAR_DATE_INTERVAL', {
            startDate: dateFrom,
            endDate: dateTo,
        })

        //download the needed events
        state.isloadingEvents = true;

        axios.get('api/calendar/GetEvents', {
            params: {
                supplierId: supplierId,
                dateFrom: dateFrom,
                dateTo: dateTo
            },
        }).then(function(response) {
            let returnedEvents = []
            if (response && response.status === 200) {
                for (let event of response.data.events) {
                    returnedEvents.push(event)
                }
            }

            state.isloadingEvents = false;
            if(returnedEvents.length == 0){
                commit('FLUSH_EVENTS');
            } else {
                commit('ADD_TO_STORED_EVENTS', returnedEvents);
            }
            dispatch('prepareEventDates');
        })

    },

    prepareEventDates: ({state, commit}) => {
        let eventsArr = []
        for (var date in state.storedDates) {
            for (let event of state.storedDates[date].events) {
                eventsArr.push(event);
            }
        }
        commit('UPDATE_STORED_EVENTS', eventsArr);
    },

    flushEvents: ({commit}) => {
        commit('FLUSH_EVENTS');
    },

    removeDayFromCache: ({state, dispatch}, date) => {
        //remove from stored dates
        if(state.storedDates[date]){
            delete state.storedDates[date]
        }

        //remove from stored events
        dispatch('prepareEventDates');
    },

    setAsCreatingSingleEvent: ({state, rootState}) => {
        state.isCreatingSingleEvent = true;
        state.selectedEvent = {
            id: null,
            availabilityType: 0,
            shareType:0,
            supplierId: 13,
            start: moment().format('YYYY-MM-DD 14:00:00'),
            end: moment().format('YYYY-MM-DD 15:00:00'),
            duration: "02:00:00",
            location: null,
            locationId: null,
            locationMain: null,
            isPrivateEvent: false,
            manualConfirmation: false,
            notes: "",
            status: 1,
            statusMessage: null,
            hasLotation: true,
            maximumLotation: 0,
            quantityAvailable: 0,
            quantityBooked: 0,
            totalPAXCheckedIn: 0,
            totalPAXNoShow: 0,
            salesPermissionsTeam: true,
            salesPermissionsWebsite: true,
            salesPermissionsAgents: true,
            salesPermissionsAgentsCustom: false,
            salesPermissionsAgentsList: [],
            salesBlockedAgentList: [],
            isPriceIncludeTaxes: true,
            eventGenderPrices:  [
                {
                    genderPriceType: 1,
                    isExcludedFromBilling: false,
                    value: 0,
                    currency: "€",
                    isTaxIncludedInPrice: true,
                    vatType: 0,
                    productGenderPriceComponents: []
                },
            ],
            eventNotes: [],
            eventAlotments: [],
            eventComponents: [],
            eventOccupancyList: [],
            product: null,
            eventResources: [],
            eventRoutes: [],
            helperProduct: null,
            channelCommissions: []
        }
    },

    setAsNotCreatingSingleEvent: ({state}) => {
        state.isCreatingSingleEvent = false;
    },

    removeEventFromStored: ({state}, eventId) => {
        state.storedEvents = state.storedEvents.filter(storedEvent => {
            return storedEvent.id != eventId
        })
    },

    downloadSingleEvent: ({state, dispatch, rootState}, eventId) => {
        // receives an eventId, downloads it from API and if it alread exists on storedEvents replaces it,
        // if not present on storedEvents it adds it
        return axios.get('/api/calendar/GetEvents', {
            params:{
                supplierId: rootState.user.account.supplierId,
                eventId: eventId
            }
        }).then(response => {
            if(response.status && response.status == 200){
                dispatch('removeEventFromStored', eventId)
                state.storedEvents.push(response.data.events[0])
            }
            return response
        }).catch(err => {
            console.log(err);
        })
    },
    changefilterBlacklistProducts: function ({commit}, payload) {
        payload = payload == null? [] : payload
        commit('UPDATE_FILTERS_BLACKLIST_PRODUCTS', payload)
    }
};

const mutations = {
    UPDATE_EXPANDED_DATE: (state, date) => {
        state.expandedDay = date;
    },

    UPDATE_CURRENT_VIEW: (state, view) => {
        state.currentView = view;
    },

    UPDATE_CALENDAR_SIDEBAR: (state, date) => {
        var headers = document.querySelectorAll('.fc-day-header');
        var current = document.querySelector(".fc-day-header[data-date='" + date + "']");

        state.expandedDay = date;
        state.selectedEvent = null;

        // Update UI

        if (headers) {
            [].forEach.call(headers, i => i.classList.remove('selected'));
        }

        if (current) {
            current.classList.add('selected');
        }
    },

    UPDATE_SELECTED_EVENT: (state, event) => {
        state.selectedEvent = event;
    },

    TOGGLE_CALENDAR_FILTER: (state, data) => {
        state.filters[data.filter] = data.value;
    },

    SET_SELECTED_NOTE: (state, note) => {
        state.selectedNote = note;
    },

    CLEAR_SELECTED_NOTE: (state) => {
        state.selectedNote = null;
    },

    UPDATE_SELECTED_NOTE: (state, note) => {
        let index = _.findIndex(state.selectedEvent.notes, {id: note.id});

        if (index !== null) {
            Vue.set(state.selectedEvent.notes, index, note);
        }
    },

    UPDATE_EVENT_NOTE_LIST: (state, notes) => {
        state.eventNotes = notes;
    },

    UPDATE_EDIT_EVENT_TAB: (state, tabName) => {
        state.editEventTab = tabName
    },

    CANCEL_EVENT_EDIT: (state, oldEvent) => {
        state.selectedEvent = oldEvent;
    },

    ADD_TO_STORED_EVENTS: (state, events) => {
        // first we group the events per day
        let eventsPerDay = {};
        for (let event of events) {
            let currentEventDay = event.start.split(" ")[0];

            if(eventsPerDay[currentEventDay] == undefined){
                eventsPerDay[currentEventDay] = currentEventDay;
                eventsPerDay[currentEventDay] = {
                    date: currentEventDay,
                    pullTime: moment(),
                    events: []
                };
            }

            eventsPerDay[currentEventDay].events.push(event);

        }
        //debug
        //console.log(eventsPerDay);

        //the we merge it with the stored Array
        for (let newDay in eventsPerDay) {

            state.storedDates[newDay] = eventsPerDay[newDay];

        }

    },

    UPDATE_STORED_EVENTS: (state, eventsArr) => {
        state.storedEvents = eventsArr;
    },

    FLUSH_EVENTS: (state) => {10
        state.storedDates = [];
        state.getStoredDates = [];
    },
    UPDATE_FILTERS_BLACKLIST_PRODUCTS: (state, newProdArray) => {
        state.filterBlacklistProducts = newProdArray
    },

    UPDATE_CALENDAR_DATE_INTERVAL: (state, interval) => {
        state.dateInterval = interval
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/calendar.js